module.exports = __webpack_public_path__ + "img/loading_checkout.5c81aa02.svg";